import React, { useEffect, useState } from 'react';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import * as S from './styles';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import KOGCollapse from '@/main/components/shared/kogCollapse/kogCollapse';
import { KeyValue } from '@/main/models/common';
import {
  CompaniesWillSeeFilters,
  ICompaniesWillSeeFormSearch
} from './companiesWillSeeFilters';
import { CompanyAnnouncementFilterRequest } from '@/main/models/request';
import { announcementApi } from '@/main/api';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import { CompaniesAvailableResponse } from '@/main/models/response/announcementResponse';
import CompaniesWillSeeGrid from './companiesWillSeeGrid';
import { FormProvider, useForm } from 'react-hook-form';
import { AnnouncementCompaniesSaveRequest } from '@/main/models/request/announcementRequest';
import { toast } from 'react-toastify';

interface IModalCompaniesWillSee {
  isOpenModal: boolean;
  closeModal: (refresh?: boolean) => void;
  optionsCompanyType: KeyValue[] | null;
  guidCompanyAnnouncer: string;
  guidAnnouncement: string;
}

function ModalCompaniesWillSeeContent({
  closeModal,
  optionsCompanyType,
  isOpenModal,
  guidCompanyAnnouncer,
  guidAnnouncement
}: IModalCompaniesWillSee) {
  const [resetTrigger, setResetTrigger] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false);
  const [isLoadingGrid, setIsLoadingGrid] = useState<boolean>(false);
  const [companiesAvailable, setCompaniesAvailable] = useState<
    CompaniesAvailableResponse[]
  >([]);

  const [pageIndex, setPageIndex] = useState<number>(
    PaginationEnum.PageIndexIntial
  );
  const [hasMore, setHasMore] = useState<boolean>(false);

  const methods = useForm<AnnouncementCompaniesSaveRequest>({
    defaultValues: {
      guidCompanies: []
    }
  });

  const { handleSubmit, reset, watch } = methods;
  const watcherCompanies = watch('guidCompanies');

  const [
    filterRequest,
    setFilterRequest
  ] = useState<CompanyAnnouncementFilterRequest | null>(null);

  function onReset() {
    setResetTrigger(prev => prev + 1);
    setFilterRequest(null);
    setCompaniesAvailable([]);
    reset();
  }

  function onSearch(formData: ICompaniesWillSeeFormSearch) {
    const request: CompanyAnnouncementFilterRequest = {
      guidAnnouncement,
      companyName: formData.companyName,
      idCompanyType: isNullUndefined(formData.companyType)
        ? undefined
        : Number(formData.companyType.key),
      registrationNumber: formData.rfc,
      guidCompanyAnnouncer: guidCompanyAnnouncer,
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize15
    };

    setFilterRequest(request);
    setPageIndex(PaginationEnum.PageIndexIntial);
    setIsLoading(true);
    setIsLoadingGrid(true);
    reset();

    announcementApi
      .getAvailableCompaniesAnnouncement(request)
      .then(res => {
        const {
          data: { results, totalNumberOfRecords }
        } = res;
        if (results) {
          setCompaniesAvailable(results);
          setHasMore(totalNumberOfRecords > results.length);
        }
      })
      .catch(() => {
        setCompaniesAvailable([]);
      })
      .finally(() => {
        setIsLoading(false);
        setIsLoadingGrid(false);
      });
  }

  function loadMore() {
    if (!filterRequest || !hasMore || isLoading) return;

    const nextPage = pageIndex + 1;

    const request = {
      ...filterRequest,
      pageIndex: nextPage
    };

    setIsLoadingGrid(true);

    announcementApi
      .getAvailableCompaniesAnnouncement(request)
      .then(res => {
        const results = res.data?.results ?? [];

        setCompaniesAvailable(prev => [...prev, ...results]);
        setPageIndex(nextPage);
        setHasMore(results.length === PaginationEnum.PageSize15);
      })
      .catch(() => {
        setCompaniesAvailable([]);
      })
      .finally(() => {
        setIsLoadingGrid(false);
      });
  }
  function onSave(formData: AnnouncementCompaniesSaveRequest) {
    setIsLoadingSave(true);

    const request: AnnouncementCompaniesSaveRequest = {
      guidAnnouncement,
      guidCompanies: formData.guidCompanies
    };
    announcementApi
      .saveCompanies(request)
      .then(res => {
        const { result } = res.data;

        if (result) {
          toast.success('Comapanias salvas');
          onReset();
          closeModal(true);
        }
      })
      .finally(() => {
        setIsLoadingSave(false);
      });
  }

  useEffect(() => {
    onReset();
  }, [isOpenModal]);

  const showCompaniesSection = companiesAvailable.length > 0;

  if (isNullUndefined(optionsCompanyType)) return <></>;
  return (
    <S.Container>
      <S.RowHeader>
        <h4>
          {getTranslateByKey('information.companiesWhoWillSeeAnnouncement')}
        </h4>
      </S.RowHeader>

      <S.ContainerCollapse>
        <KOGCollapse
          showBorder={false}
          header={
            <S.BodyBox>
              <S.Title>{getTranslateByKey('information.filters')}</S.Title>
            </S.BodyBox>
          }
          content={
            <CompaniesWillSeeFilters
              isLoading={isLoading}
              optionsCompanyType={optionsCompanyType}
              resetTrigger={resetTrigger}
              onSearch={onSearch}
              onClear={onReset}
            />
          }
          isOpenCollapseinitial={true}
        />
      </S.ContainerCollapse>

      <FormProvider {...methods}>
        {showCompaniesSection && (
          <S.ContainerCollapse>
            <KOGCollapse
              showBorder={false}
              header={
                <S.BodyBox>
                  <S.Title>{getTranslateByKey('information.register')}</S.Title>
                </S.BodyBox>
              }
              content={
                <CompaniesWillSeeGrid
                  dataCompanies={companiesAvailable}
                  isLoading={isLoading}
                  isLoadingPagination={isLoadingGrid}
                  hasMore={hasMore}
                  loadMore={loadMore}
                />
              }
              isOpenCollapseinitial={true}
            />
          </S.ContainerCollapse>
        )}

        <S.AreaButtons>
          <SecondaryButton
            id="id-modalCompanies-btn-back"
            type="button"
            onClick={() => closeModal(false)}>
            {getTranslateByKey('information.back')}
          </SecondaryButton>
          <SecondaryButton
            id="id-modalCompanies-btn-save"
            type="button"
            isLoading={isLoadingSave}
            disabled={watcherCompanies.length == 0}
            onClick={handleSubmit(onSave)}>
            {getTranslateByKey('information.save')}
          </SecondaryButton>
        </S.AreaButtons>
      </FormProvider>
    </S.Container>
  );
}

export function ModalCompaniesWillSee(props: IModalCompaniesWillSee) {
  return (
    <KogModalSideComponent
      open={props.isOpenModal}
      width="700px"
      closeModal={() => props.closeModal(false)}>
      <ModalCompaniesWillSeeContent {...props} />
    </KogModalSideComponent>
  );
}
